var exports = {
  "N": "xe564cbfb--39f3f1--element",
};

module.exports = exports;
